export default "__VITE_ASSET__DIBsTOa7__"